<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
    <div class="section">
      <div class="sectionHeader">
          <div class="header">
            <div class="title">
                <div class="label">
                    {{'PAYMENT_ADVICE.title' | translate}}
                </div>
                <div class="help">
                  <!--  <app-help [helpData]="helpData" ></app-help> -->
                </div>
  
                <!-- <div class="date">
                  June
                </div> -->
              </div>
  
          </div>
        </div>
  
        <div class="historyMain">
          <div class="filter">
            <div class="container">
              <div class="title">
                {{'PAYMENT_ADVICE.historyTitle' | translate}}
              </div>
              <div class="search">
                  <!-- <div class="inputSearch">
                      <input (keyup)="applyFilter($event.target.value)" placeholder=""  class="inputSelect">
                  </div> -->
              </div>
              <div class="select-date">
                  <div class="title">
                          {{'CREATE_BILLS.from' | translate}}    
                  </div>
                  <div >
                      <input type="text" class="dateSelect" [matDatepicker]="from_date"  [(ngModel)]="date_filter.from_date" [max]="date_filter.max" (click)="from_date.open()"/>
                      <mat-datepicker #from_date (closed)="setFromDateTime(date_filter)" [startAt]="date_filter.from_date"></mat-datepicker>
                      <i class="material-icons calendar">date_range</i>
                  </div>
              </div>

              <div class="select-date">
                  <div class="title">
                          {{'CREATE_BILLS.to' | translate}}    
                  </div>
                  <div >
                      <input type="text" class="dateSelect" [matDatepicker]="to_date" [(ngModel)]="date_filter.to_date" [min]="date_filter.min" (click)="to_date.open()"/>
                      <i class="material-icons icon calendar">date_range</i>
                      <mat-datepicker #to_date (closed)="setToDateTime(date_filter)" [startAt]="date_filter.to_date" ></mat-datepicker>
                  </div>
              </div>
         </div>
        </div>
        </div>
          <div class="tableMain">
            <div class="table" >
              <table mat-table class="mat-elevation-z2" #table [dataSource]="invoicesList.filteredData" *ngIf="invoicesList && invoicesList.filteredData.length;else noAdvice ">
  
                <ng-container matColumnDef="advice_no">
                  <th mat-header-cell *matHeaderCellDef>
                      {{'PAYMENT_ADVICE.advice_no' | translate}}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a href={{element.pdf_link}} *ngIf="element.pdf_link" download>
                      {{element.adviceNumber || 'N/A'}}
                    </a>
                    <div *ngIf="!element.pdf_link">
                      {{element.adviceNumber || 'N/A'}}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="bill_no">
                  <th mat-header-cell *matHeaderCellDef>
                      {{'PAYMENT_ADVICE.bill_no' | translate}}
                  </th>
                  <td mat-cell *matCellDef="let element" class="billSection">
                    <div *ngIf="element.carrier_bills && element.carrier_bills.length">
                        <div *ngFor="let bill of element.carrier_bills" class="billIDs">
                          {{bill.CBIN.default}}
                        </div>
                    </div>
                    <div *ngIf="!element.carrier_bills || !element.carrier_bills.length">
                      N/A
                    </div>
                  </td>
              </ng-container>
                      <ng-container matColumnDef="sin">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'PAYMENT_ADVICE.sin' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" class="billSection">
                          <div *ngIf="element.shipments && element.shipments.length">
                              <div *ngFor="let item of element.shipments" class="billIDs">
                                {{item.SIN}}
                              </div>
                          </div>
                          <div *ngIf="!element.shipments || !element.shipments.length">
                            N/A
                          </div>
                        </td>
                    </ng-container>
  
                      <ng-container matColumnDef="transaction_id">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'PAYMENT_ADVICE.transaction_id' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">{{element.transaction_id || 'N/A'}}</td>
                      </ng-container>
  
                      <ng-container matColumnDef="payment_mode">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'PAYMENT_ADVICE.payment_mode' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">{{element.payment_mode}}</td>
                      </ng-container>
  
                      <ng-container matColumnDef="payment_date">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'PAYMENT_ADVICE.payment_date' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">{{element.payment_date}}</td>
                      </ng-container>
  
                      <ng-container matColumnDef="bank_details">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'PAYMENT_ADVICE.bank_details' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element" class="bankDetails">
                            <span *ngIf="element.bankDetails && element.bankDetails.bank_name;else noAccount">
                              {{'PAYMENT_ADVICE.bank_name' | translate}}: {{element.bankDetails.bank_name}}<br>
                              {{'PAYMENT_ADVICE.acc_no' | translate}}: {{element.bankDetails.account_no}}<br>
                              {{'PAYMENT_ADVICE.ifsc' | translate}}: {{element.bankDetails.IFSC_no}}
                            </span>
                            <ng-template #noAccount>
                              N/A
                            </ng-template>
                          </td>
                      </ng-container>
                      
                      <ng-container matColumnDef="gross">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'PAYMENT_ADVICE.gross' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">{{symbol}} {{element.gross_amount}}</td>
                    </ng-container>
  
                    <ng-container matColumnDef="deduction">
                      <th mat-header-cell *matHeaderCellDef>
                          {{'PAYMENT_ADVICE.deductions' | translate}}
                      </th>
                      <td mat-cell *matCellDef="let element">{{symbol}} {{element.deduction}}</td>
                  </ng-container>

                      <ng-container matColumnDef="net">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'PAYMENT_ADVICE.net' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">{{symbol}} {{element.net_amount}}</td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="row.expand = !row.expand" ></tr>
                  </table>
                  <mat-paginator [length]="(invoicesList)? totalAdvices:0" [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons
                      (page)="pageNavigate($event)" style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"></mat-paginator>
            </div>
            <ng-template #noAdvice>
              <div class="noAdvice">
                      {{'PAYMENT_ADVICE.no_advices_found' | translate}}
              </div>
            </ng-template>
        </div>
      </div>
  </div>
  